import { i18n } from '@/plugins/i18n'
import yup from '@/plugins/yup'

const { t } = i18n.global

const AlarmReportSearchBarSchema = yup.object({
  group: yup.object().nullable(),
  period: yup
    .array()
    .of(yup.date())
    .required(
      t('errors.required', {
        label: t('alarm_report.header.actions.search.fields.period'),
      }),
    ),
  sensor_ids: yup.array().of(yup.number().integer()).default([]),
  alarm_types: yup.array().of(yup.string()).default([]),
  classification_type_ids: yup.array().of(yup.number().integer()).default([]),
  shift: yup.object().nullable(),
})

export default AlarmReportSearchBarSchema
